// ShortClipCard.tsx — a portrait tile for the "Short Clips" row (concept: 9:16 poster,
// title, @handle, likes). Opens the vertical Shorts player.
import { Link } from 'react-router-dom';
import { flashPath } from '../flashPath';
import styled from 'styled-components';
import type { VideoCreator, VideoItem } from '@/core/models/video';
import { Icon } from '@/icons';
import { VideoThumb } from '../VideoThumb';

const Tile = styled(Link)`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  text-decoration: none;
`;

const Thumb = styled.div`
  position: relative;
  aspect-ratio: 9 / 16;
  max-height: 240px;
  border-radius: ${({ theme }) => theme.radius.md};
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.color.glassBorder};
`;

const Title = styled.span`
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: 600;
  color: ${({ theme }) => theme.color.textPrimary};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const Meta = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.xs};
  color: ${({ theme }) => theme.color.textMuted};
`;

export interface ShortClipCardProps {
  video: VideoItem;
  creator?: VideoCreator;
  likes?: number;
}

export function ShortClipCard({ video, creator, likes }: ShortClipCardProps) {
  return (
    <Tile to={flashPath(video.id)} aria-label={`Play Flash: ${video.title}`}>
      <Thumb>
        <VideoThumb video={video} compact />
      </Thumb>
      <Title>{video.title}</Title>
      {creator && <Meta>{creator.handle}</Meta>}
      {likes !== undefined && (
        <Meta>
          <Icon name="cherish" size={12} />
          {likes}
        </Meta>
      )}
    </Tile>
  );
}
